/**
 * Created by fers on 03.08.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {viewWithDataGetPrimaryData} from './PrimaryData';

export class ParentBox extends React.Component {

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "";
    }

    fakeValue(value, fake) {
        if (this.props.isPreview) {
            return fake;
        } else {
            return value;
        }
    }

	static isEmpty(viewWithData) {
		let data = viewWithDataGetPrimaryData(viewWithData);

		return !data || data.length === 0;
	}

    render() {
        return (<span>?</span>);
    }
}

export function relayWrap(className) {
    return className;
}
